export default {
  'overview.title': '总览',
  'overview.totalRevenue': '总收入',
  'overview.totalRevenueHint': '区间内已支付金额',
  'overview.paidOnly': '仅统计已支付订单',
  'overview.totalOrders': '总单数',
  'overview.paidOrdersHint': '已支付 {n} 单',
  'overview.newOrders': '新增订单',
  'overview.newOrdersHint': '不含续费',
  'overview.subscriptionOrders': '订阅订单',
  'overview.subscriptionOrdersDesc': '勾选订阅计划的订单',
  'overview.oneTimeOrders': '单次订单',
  'overview.oneTimeOrdersDesc': '非订阅的一次性购买',
  'overview.renewalOrders': '续费订单数',
  'overview.renewalOrdersHint': '区间内续费共 {total} 笔',
  'overview.renewalAmount': '续费金额',
  'overview.renewalAmountHint': '续费已支付金额',
  'overview.renewalTitle': '续费订单',
  'overview.renewalHint': '已续费 + 待扣费',
  'overview.renewalCountDesc': '区间内续费成功',
  'overview.pendingCharge': '待扣费订单',
  'overview.pendingChargeDesc': '区间内待扣费',
  'overview.share': '占新增 {pct}',
  'overview.ofRenewalTotal': '占合计 {pct}',
};
